import { useRef, useState } from "react";
import { fmt } from "@/lib/api";

const AmountInput = ({ amount, setAmount, disabled, balance }) => {
  const adj = (f) => setAmount((a) => Math.max(0, Math.round(Number(a || 0) * f * 100) / 100).toFixed(2));
  return (
    <div>
      <div className="flex justify-between">
        <span className="x-label">Bahis Tutarı</span>
        <span className="text-[13px] font-semibold text-[var(--x-muted)] tabular-nums">₺{fmt(Number(amount || 0))}</span>
      </div>
      <div className="flex rounded-md overflow-hidden bg-[var(--x-panel-2)] p-[2px] gap-[2px]">
        <div className="relative flex-1">
          <input
            data-testid="bet-amount-input"
            type="number"
            inputMode="decimal"
            disabled={disabled}
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="x-input border-0 rounded-[4px] pr-8"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--x-muted)] font-bold">₺</span>
        </div>
        <button data-testid="bet-half-btn" disabled={disabled} onClick={() => adj(0.5)} className="px-4 font-bold hover:bg-[#3d4357] rounded-[4px] transition-colors">½</button>
        <button data-testid="bet-double-btn" disabled={disabled} onClick={() => adj(2)} className="px-4 font-bold hover:bg-[#3d4357] rounded-[4px] transition-colors">2×</button>
        <button data-testid="bet-max-btn" disabled={disabled} onClick={() => setAmount(Number(balance).toFixed(2))} className="px-3 text-[13px] font-bold hover:bg-[#3d4357] rounded-[4px] transition-colors">Maks</button>
      </div>
    </div>
  );
};

export const BetControls = ({ busy, play, balance }) => {
  const [mode, setMode] = useState("manual");
  const [amount, setAmount] = useState("10.00");
  const [count, setCount] = useState("10");
  const [auto, setAuto] = useState(false);
  const [lastBet, setLastBet] = useState(null);
  const stopRef = useRef(false);

  const manual = async () => {
    const a = Number(amount);
    setLastBet(a);
    await play(a);
  };

  const startAuto = async () => {
    stopRef.current = false;
    setAuto(true);
    const n = Number(count) || 0;
    for (let i = 0; n === 0 || i < n; i++) {
      if (stopRef.current) break;
      const ok = await play(Number(amount));
      if (!ok) break;
      if (n) setCount(String(n - i - 1));
    }
    setAuto(false);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 bg-[var(--x-bg-deep)] rounded-full p-1.5">
        {[["manual", "Manuel"], ["auto", "Oto"]].map(([k, l]) => (
          <button
            key={k}
            data-testid={`bet-mode-${k}`}
            disabled={busy || auto}
            onClick={() => setMode(k)}
            className={`rounded-full py-2 text-sm font-bold transition-colors ${mode === k ? "bg-[var(--x-panel-2)]" : "text-[var(--x-muted)] hover:text-white"}`}
          >
            {l}
          </button>
        ))}
      </div>
      <AmountInput amount={amount} setAmount={setAmount} disabled={busy || auto} balance={balance} />
      {mode === "manual" ? (
        <>
          <button data-testid="place-bet-btn" disabled={busy} onClick={manual} className="x-btn x-btn-primary w-full py-4 text-[17px]">
            {busy ? "Kayıyor..." : "Bahis Yap"}
          </button>
          <button
            data-testid="repeat-bet-btn"
            disabled={busy || lastBet === null}
            onClick={() => { setAmount(lastBet.toFixed(2)); play(lastBet); }}
            className="x-btn x-btn-secondary w-full py-3.5"
          >
            Son Bahsi Tekrarla
          </button>
        </>
      ) : (
        <>
          <div>
            <span className="x-label">Bahis Sayısı <span className="text-[var(--x-dim)]">(0 = sınırsız)</span></span>
            <input data-testid="auto-count-input" type="number" disabled={auto} className="x-input" value={count} onChange={(e) => setCount(e.target.value)} />
          </div>
          {auto ? (
            <button data-testid="auto-stop-btn" onClick={() => (stopRef.current = true)} className="x-btn x-btn-red w-full py-4 text-[17px]">Otomatik Bahsi Durdur</button>
          ) : (
            <button data-testid="auto-start-btn" disabled={busy} onClick={startAuto} className="x-btn x-btn-primary w-full py-4 text-[17px]">Otomatik Bahsi Başlat</button>
          )}
        </>
      )}
    </div>
  );
};
